import { create } from 'zustand';

const initialState = {
  isLoggedIn: null,
  accessToken: null,
  tokenExpiry: null,
};

export const useAuthStore = create((set) => ({
  ...initialState,
  
  setIsLoggedIn: (isLoggedIn) => set({ isLoggedIn }),
  setAccessToken: (accessToken) => set({ accessToken }),
  setTokenExpiry: (tokenExpiry) => set({ tokenExpiry }),
  resetAuth: () => set(initialState),
}));

export const useIsLoggedIn = () => useAuthStore(state => state.isLoggedIn);
export const useAccessToken = () => useAuthStore(state => state.accessToken);
export const useTokenExpiry = () => useAuthStore(state => state.tokenExpiry);

export const useSetIsLoggedIn = () => useAuthStore(state => state.setIsLoggedIn);
export const useSetAccessToken = () => useAuthStore(state => state.setAccessToken);
export const useSetTokenExpiry = () => useAuthStore(state => state.setTokenExpiry);
export const useResetAuth = () => useAuthStore(state => state.resetAuth);
